import makeRequest from 'utils/makeRequest'
import { PUBLIC_ENDPOINTS } from 'config/apiEndpoints'
import IResponseApi from 'models/IResponseApi'
import IFeedback from 'models/IFeedback'

export const actionMenuService = {
  getOpeningHours: async (slug: string): Promise<IResponseApi> => {
    try {
      const url = `${PUBLIC_ENDPOINTS.GetOpeningHours}?slug=${slug}`
      const response: IResponseApi = await makeRequest('GET', url)

      return response
    } catch (error) {
      throw new Error('Get opening hours failed')
    }
  },
  sendFeedback: async (feedbackBody: IFeedback): Promise<IResponseApi> => {
    try {
      const response: IResponseApi = await makeRequest(
        'POST',
        PUBLIC_ENDPOINTS.SendFeedback,
        JSON.stringify(feedbackBody),
        'application/json'
      )

      return response
    } catch (error) {
      throw new Error('Sending Feedback Failed')
    }
  },
}
